import { useEffect, useState } from 'react'
import { ArrowUp } from 'lucide-react'
import { scrollToTop } from '../lib/motion'

const BackToTop: React.FC = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <button
      onClick={() => scrollToTop(true)}
      aria-label="Back to top"
      className={`fixed bottom-6 right-6 z-40 flex items-center justify-center w-11 h-11 rounded-lg bg-neutral-900 dark:bg-neutral-800 border border-neutral-200 dark:border-white/10 text-neutral-200 dark:text-neutral-100 shadow-soft hover:border-primary-400/50 hover:text-primary-300 transition-all duration-300 ${
        visible
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
    >
      <ArrowUp size={18} />
    </button>
  )
}

export default BackToTop